<p>modal-loading-overlay-close works!</p>
